module.exports = "/assets/data/4a938e5b58f8d76e011aa4bbacfa9e28-CR7.data.json";